// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"b3fa69cb","173":"4fa242a1","787":"cdb5a671","822":"e65056e6","867":"c2dd3366","910":"e641ffeb","925":"ffca19aa","940":"f1855891"}[chunkId] + ".chunk.js";
};